import React, { useState } from "react";
import { login } from "./api";

function LoginScreen({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const result = await login({ username, password });
      onSuccess?.({
        token: result?.token,
        user: result?.user || result?.raw?.user || null,
      });
    } catch (err) {
      const message = err?.message || "No se pudo iniciar sesión";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-950 to-black flex items-center justify-center p-6">
      <div className="w-full max-w-lg bg-white/90 backdrop-blur rounded-2xl shadow-xl border border-slate-200 p-8">
        <div className="mb-6">
          <p className="text-xs uppercase font-semibold tracking-[0.25em] text-slate-500">
            Acceso requerido
          </p>
          <h1 className="text-2xl font-bold text-slate-900 mt-1">
            Inicia sesión
          </h1>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Usuario
            </label>
            <input
              type="text"
              autoComplete="username"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-4 py-3 text-slate-800 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              placeholder="admin"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Contraseña
            </label>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-4 py-3 text-slate-800 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              placeholder="********"
            />
          </div>

          {error && (
            <div className="rounded-lg bg-rose-50 text-rose-700 px-4 py-3 text-sm border border-rose-100">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className={`w-full px-6 py-3 rounded-lg font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
              loading
                ? "bg-blue-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {loading ? "Validando..." : "Iniciar sesión"}
          </button>
        </form>

      </div>
    </div>
  );
}

export default LoginScreen;
